/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Eye Outline Icon component.
 */
export const SystemEyeOutlineIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12.1387 4C17.1551 4 21.436 7.12086 23.1699 11.5205L23.2783 11.7959L23.1699 12.0703C21.436 16.47 17.1551 19.5908 12.1387 19.5908C7.1225 19.5905 2.84117 16.4698 1.10742 12.0703L1 11.7959L1.10742 11.5205C2.84117 7.12099 7.1225 4.00033 12.1387 4ZM12.1387 5.5C7.86688 5.50032 4.20065 8.09335 2.61719 11.7949C4.20044 15.497 7.86653 18.0905 12.1387 18.0908C16.411 18.0908 20.0767 15.497 21.6602 11.7949C20.0765 8.09333 16.4106 5.5 12.1387 5.5ZM12.1396 7.09863C14.7323 7.09873 16.8369 9.20323 16.8369 11.7959C16.8367 14.3884 14.7321 16.4921 12.1396 16.4922C9.54707 16.4922 7.44262 14.3884 7.44238 11.7959C7.44238 9.20317 9.54692 7.09863 12.1396 7.09863ZM12.1396 8.97754C10.5803 8.97754 9.32129 10.2365 9.32129 11.7959C9.32153 13.3551 10.5804 14.6133 12.1396 14.6133C13.6988 14.6132 14.9578 13.355 14.958 11.7959C14.958 10.2366 13.699 8.97764 12.1396 8.97754Z' fill={iconColor} />
    </svg>
  );
};

export default SystemEyeOutlineIcon;
